import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=1789752c&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=1789752c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789752c",
  null
  
)

export default component.exports